/* ===================================================================
   MOBILE BG FIX — 2026-05-23
   Stale Fastly CDN nodes may serve old index.json rendering that sets
   background_image_mobile to Vital-Origin-1500x1500-02-1-scaled.jpg
   (green Beef Kidney infographic) instead of shop-by-benefits-mobile.png.
   This patch runs before lazy images load and swaps the wrong <source>
   srcset to the correct brown mobile background.
   Self-limiting: no-op once CDN propagates correct HTML.
   =================================================================== */
(function () {
  var WRONG = 'Vital-Origin-1500x1500-02-1-scaled';
  var CORRECT = 'https://cdn.shopify.com/s/files/1/0774/1548/1572/files/shop-by-benefits-mobile.png?v=1765986345';
  function fixMobileBg() {
    document.querySelectorAll('picture source[media]').forEach(function (src) {
      var m = src.getAttribute('media') || '';
      var s = src.getAttribute('srcset') || '';
      if (m.indexOf('749px') !== -1 && s.indexOf(WRONG) !== -1) {
        src.setAttribute('srcset', CORRECT);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMobileBg);
  } else {
    fixMobileBg();
  }
})();

/* ===================================================================
   BUNDLER + SEAL — DEFAULT TO SUBSCRIBE ON PAGE LOAD
   Seal defaults to One-time selected when no admin toggle exists.
   This script waits for Seal's purchase-options radios to appear,
   then programmatically clicks the Subscribe radio (data-type="subscription"
   OR value="0" inside .sls-purchase-options-container) IF One-time is
   currently selected. Idempotent — bails if Subscribe is already selected.
   Added: 2026-05-21
   =================================================================== */
(function () {
  var MAX_TRIES = 40;     // ~8 sec total at 200ms interval
  var INTERVAL_MS = 200;

  function trySelectSubscribe(tries) {
    if (tries > MAX_TRIES) return;

    // Find Seal's purchase-options group inside any Bundler subscription container
    var container = document.querySelector(
      '.bndlr-subscription-container .sls-purchase-options-container'
    );
    if (!container) return setTimeout(function () { trySelectSubscribe(tries + 1); }, INTERVAL_MS);

    // Subscribe radio: name pattern subs_type_*, data-type="subscription"
    var subscribeRadio = container.querySelector(
      'input.sls-option[data-type="subscription"]'
    );
    var oneTimeRadio = container.querySelector(
      'input.sls-option[data-type="one_time"]'
    );

    if (!subscribeRadio) return setTimeout(function () { trySelectSubscribe(tries + 1); }, INTERVAL_MS);

    // If Subscribe already selected, no-op
    if (subscribeRadio.checked) return;

    // Click the subscribe radio's clickable parent (Seal listens on the
    // .sls-selling-plan-group-first-line[role="radio"] wrapper, not the input)
    var clickTarget = subscribeRadio.closest('.sls-selling-plan-group-first-line[role="radio"]')
      || subscribeRadio.closest('.seal-col-radio')
      || subscribeRadio;

    try {
      clickTarget.click();
    } catch (e) {
      // Fallback: set checked + fire change event manually
      subscribeRadio.checked = true;
      subscribeRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      trySelectSubscribe(0);
    });
  } else {
    trySelectSubscribe(0);
  }
})();
